import { Text, VStack } from '@chakra-ui/layout';

import { PagePaths } from '@revelio/core';

import { DeliverableStepContainer } from '../deliverable-step-container';
import { DeliverablePaths } from '../deliverables-page';
import type { DataInterface } from '../file-upload/file-upload.types';
import {
  DEFAULT_TAXONOMY_ID,
  useDataEnrichmentActions,
} from './data-enrichment.store';
import CompletedStatusIcon from './icons/CompletedStatusIcon';
import type { SelectedOptionsInterface } from './types/dataEnrichmentTypes';

const CompletedStep = ({
  setData,
  setActiveStep,
  setSelectedOptions,
}: {
  setData: React.Dispatch<React.SetStateAction<DataInterface>>;
  setActiveStep: (step: number) => void;
  setSelectedOptions: React.Dispatch<
    React.SetStateAction<SelectedOptionsInterface[]>
  >;
}) => {
  const { setEnrichmentJobTaxonomySettings, setEnrichmentModals } =
    useDataEnrichmentActions();
  const reset = () => {
    setData({
      workbook: { Sheets: {}, SheetNames: [] },
      sheetNames: [],
      mappedWorkbook: [[]],
      selectedSheet: '',
      headers: [],
      headerIndex: '',
      combinedData: [{}],
      fileType: 'csv',
      mappedColumns: [],
      oryId: '',
      clientName: '',
      email: '',
      s3FileLocation: '',
    });
    setActiveStep(0);
    setSelectedOptions([]);
    setEnrichmentModals([]);
    setEnrichmentJobTaxonomySettings({
      taxonomyId: DEFAULT_TAXONOMY_ID,
      includeV2: false,
    });
  };
  return (
    <DeliverableStepContainer
      id="completed"
      title="Completed"
      startOverPath={`/${PagePaths.DELIVERABLES}/${DeliverablePaths.DATASET}`}
      submitButtonContent="Upload Another"
      onSubmit={reset}
      disableFade
      isDataBuilder={false}
    >
      <VStack w="full" h="full" alignItems="center" justifyContent="center">
        <CompletedStatusIcon />
        <Text align="center">
          Enrichment in progress. <br />
          You'll receive an email shortly with a download link to your enriched
          dataset.
        </Text>
      </VStack>
    </DeliverableStepContainer>
  );
};

export default CompletedStep;
